import { Box, Typography, styled, IconButton } from "@mui/material";
import { colors } from "../../../../theme/colors";

export const SectionContainer = styled(Box)({
  marginBottom: "32px",
});

export const TitleRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "16px",
  height: "32px",
  marginBottom: "16px",
});

export const SectionTitle = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
});

export const SectionContent = styled(Typography)({
  fontFamily: "Nunito",
  fontSize: "16px",
  color: colors.text.secondary,
  lineHeight: 1.6,
});

export const EditIconButton = styled(IconButton)({
  padding: "4px",
  flexShrink: 0,
});

export const SaveIconButton = styled(IconButton)({
  padding: "4px",
  flexShrink: 0,
});

export const CancelIconButton = styled(IconButton)({
  padding: "4px",
  flexShrink: 0,
});

export const EditorActions = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  flexShrink: 0,
});
